import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { MenuItem, Select, Stack, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import NullCheck from "components/NullCheck";
import { Diversity2, ManageSearchOutlined } from "@mui/icons-material";
import CustomButton from "components/CustomButton";
import CustomIconButton from "components/CustomIconButton";
import { useSelector } from "react-redux";

const Header = ({
  setSelectedArea,
  setSelectedMcStatus,
  selectedMcStatus,
  areas,
  mcStatus,
  setSelectedDevice,
  deviceList,
  selectedDevice,
  selectedArea,
  setTextSearch,
  textSearch,
  setOpenRelayGroup
}) => {
  const theme = useTheme()
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const biz = useSelector((state) => state?.biz?.data);

  return (
    <Stack
      width="100%"
      direction={{ xs: "column", md: "row" }}
      spacing={{ xs: 1, md: 2 }
      }>

      <Stack direction="row" spacing={{ xs: 1, md: 2 }}>
        <Select
          sx={{ width: { xs: 125, md: 140 }, bgcolor: "bg.main" }}
          size="small"
          MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
          value={selectedMcStatus}
          defaultValue={0}
          onChange={(e) => setSelectedMcStatus(e.target.value)}
        >
          {mcStatus?.map((st, index) => {
            return (
              <MenuItem key={index} value={st?.id}>
                <Typography>{bt(st?.title)}</Typography>
              </MenuItem>
            );
          })}
        </Select>

        <NullCheck valueForCheck={areas?.length > 1}>
          <Select
            sx={{ width: { xs: 125, md: 140 }, bgcolor: "bg.main" }}
            size="small"
            MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
            value={selectedArea}
            defaultValue={'all'}
            onChange={(e) => setSelectedArea(e.target.value)}
          >
            <MenuItem value={"all"}>
              <Typography>{bt("ALL_AREAS")}</Typography>
            </MenuItem>

            {areas?.map((area, index) => {
              return (
                <MenuItem key={index} value={area?.id}>
                  <Typography>{area?.name}</Typography>
                </MenuItem>
              );
            })}
          </Select>
        </NullCheck>

        <NullCheck valueForCheck={deviceList?.length > 1}>
          <Select
            sx={{ width: { xs: 125, md: 140 }, bgcolor: "bg.main" }}
            size="small"
            MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
            value={selectedDevice}
            defaultValue={'all'}
            onChange={(e) => setSelectedDevice(e.target.value)}
          >
            <MenuItem value={"all"}>
              <Typography>{bt("ALL_DEVICE")}</Typography>
            </MenuItem>

            {deviceList?.map((d, index) => {
              return (
                <MenuItem key={index} value={d}>
                  <Typography>{bt(d)}</Typography>
                </MenuItem>
              );
            })}
          </Select>
        </NullCheck>
      </Stack>

      <Stack direction="row" spacing={{ xs: 1, md: 2 }}>

        <TextField
          sx={{ width: { xs: "100%", md: 400 }, borderRadius: 3, bgcolor: "bg.main" }}
          onChange={(e) => setTextSearch(e?.target?.value)}
          value={textSearch}
          placeholder={bt("SEARCH")}
          InputProps={{
            endAdornment: <ManageSearchOutlined
              sx={{ color: textSearch !== "" ? "primary.main" : "primary.text" }}
              fontSize="small"
            />
          }}
        />

        <NullCheck valueForCheck={biz?.hasMcCommandGroup}>
          {isMobile
            ? <CustomIconButton
              size="small"
              hideBgcolor
              icon={<Diversity2 />}
              onClick={() => setOpenRelayGroup(true)}
            />
            : <CustomButton
              title="GROUP_COMMAND"
              onClick={() => setOpenRelayGroup(true)}
            />
          }
        </NullCheck>
      </Stack>

    </Stack>
  );
};
export default Header;
